import { render, staticRenderFns } from "./CircleWaveLoader.vue?vue&type=template&id=5bc4e495&scoped=true"
import script from "./CircleWaveLoader.vue?vue&type=script&lang=ts"
export * from "./CircleWaveLoader.vue?vue&type=script&lang=ts"
import style0 from "./CircleWaveLoader.vue?vue&type=style&index=0&id=5bc4e495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4e495",
  null
  
)

export default component.exports